module.exports = __webpack_public_path__ + "static/media/workloads-entity-map.166d557d.mp4";